module.exports = __webpack_public_path__ + "static/media/2.cb3e2019.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/2.png
// module id = 688
// module chunks = 0